import styled, { css } from 'styled-components';
import CloseIconSVG from '@assets/images/icons/legacy/close.svg';

interface ModalHeaderWrapperProps {
  centered?: boolean;
}

export const CloseIcon = styled(CloseIconSVG)`
  fill: ${({ theme }) => theme.color.black};
  position: absolute;
  left: ${({ theme }) => theme.x2spacePx}px;
  top: 0;
  width: ${({ theme }) => theme.x3spacePx - 1}px;
  height: ${({ theme }) => theme.x3spacePx - 1}px;
`;

export const CloseButton = styled('button')`
  position: relative;
  padding: 0 12px;
  width: ${({ theme }) => theme.x4spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;
`;

export const ModalHeaderWrapper = styled('header')<ModalHeaderWrapperProps>`
  ${({ theme, centered }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    position: relative;
    z-index: 1;
    padding: ${theme.x2spacePx}px;
    padding-left: ${theme.x3spacePx}px;
    padding-right: ${theme.x3spacePx}px;
    border-bottom: 1px solid #e8e8e8;
    color: ${theme.color.black};
    min-height: ${theme.x8spacePx}px;
    > h1 {
      ${theme.typography.largeStrong}
      margin: 0;
      text-align: ${centered ? 'center' : 'left'};
      color: ${theme.color.spaceGray};
    }
  `}
`;
